import { handleActions } from 'redux-actions';
import SideBySideViewZoom from 'models/data/side-by-side-view-zoom-model';

import {
  rightIncrementZoom,
  rightDecrementZoom,
  rightResetZoom,
} from 'store/actions/zoom-actions';
import { clearStatementPageStoreAction } from 'store/actions/statement-content-actions';

export default handleActions(
  {
    [rightIncrementZoom]: (zoom) => {
      return zoom.incrementZoom();
    },
    [rightDecrementZoom]: (zoom) => {
      return zoom.decrementZoom();
    },
    [rightResetZoom]: () => {
      return new SideBySideViewZoom();
    },
    [clearStatementPageStoreAction]: () => {
      return new SideBySideViewZoom();
    },
  },
  new SideBySideViewZoom(),
);
